import React from 'react';
import { useLang } from '@/i18n/LangContext';

const CITIES = [
  { name: { ru: 'Душанбе', tj: 'Душанбе', en: 'Dushanbe' }, role: { ru: 'Штаб-квартира', tj: 'Идораи марказӣ', en: 'Headquarters' } },
  { name: { ru: 'Худжанд', tj: 'Хуҷанд', en: 'Khujand' }, role: { ru: 'Северный хаб', tj: 'Маркази шимол', en: 'Northern hub' } },
  { name: { ru: 'Бохтар', tj: 'Бохтар', en: 'Bokhtar' }, role: { ru: 'Хатлон', tj: 'Хатлон', en: 'Khatlon' } },
  { name: { ru: 'Куляб', tj: 'Кӯлоб', en: 'Kulob' }, role: { ru: 'Юго-восток', tj: 'Ҷанубу шарқ', en: 'South-East' } },
  { name: { ru: 'Хорог', tj: 'Хоруғ', en: 'Khorog' }, role: { ru: 'ГБАО', tj: 'ВМКБ', en: 'GBAO' } },
];

export default function Geography() {
  const { t, lang } = useLang();
  return (
    <div data-testid="geo-page">
      <section className="mm-section" style={{ paddingTop: 72 }}>
        <div className="container-mm">
          <div className="eyebrow">{t.home.geo_eyebrow}</div>
          <h1 style={{ fontSize: 'clamp(48px, 6vw, 96px)', marginTop: 16 }}>{t.home.geo_title}</h1>
          <p style={{ fontSize: 18, color: 'var(--mm-slate)', marginTop: 24, maxWidth: 720 }}>
            {t.home.geo_lead}
          </p>

          <div className="mm-geo" style={{ marginTop: 56 }}>
            <div className="mm-geo-visual" data-testid="geo-map">
              <iframe
                title="MED MIR — Dushanbe, Tajikistan"
                src="https://www.google.com/maps?q=Dushanbe,Tajikistan&z=6&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, display: 'block' }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <div>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {CITIES.map((c, i) => (
                  <li key={i} style={{
                    padding: '20px 0', borderBottom: '1px solid var(--mm-line)',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                  }} data-testid={`geo-page-city-${i}`}>
                    <span style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 32 }}>{c.name[lang]}</span>
                    <span className="eyebrow" style={{ color: 'var(--mm-slate)' }}>{c.role[lang]}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
